import 'core-js';
import lloydsTheme from '@constellation/core/themes/lloyds-2023';
import {render} from 'react-dom';
import {Favicons} from '@cbbt/lui-utils';
import App from './components/App/App.js';
import AppProvider from './providers/AppProvider.js';
import configureAppStore from './redux/configureStore.js';
import {GlobalStyle} from './styles/index.js';
import {setInitialDataLayer} from './utils/analytics.js';
import {history} from './utils/index.js';

setInitialDataLayer();

// Create redux store with history
const store = configureAppStore();

render(
  <>
    <Favicons brand='LTB' />
    <AppProvider history={history} store={store} theme={lloydsTheme}>
      <GlobalStyle />
      <App />
    </AppProvider>
  </>,
  document.getElementById('app')
);
